/**
 * @file Slider.jsx
 * @description Hero section with introductory content and CTA button.
 */

import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import HeroVideo from '../new_images/vecteezy_a-laptop-screen-displaying-a-conference-with-charts-in-the_48567274.mp4';

const Slider = () => {
  return (
    <section id="intro">
      {/* Video Background */}
      <video
        autoPlay
        loop
        muted
        playsInline
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          zIndex: -2,
          opacity: 0.4,
        }}
      >
        <source src={HeroVideo} type="video/mp4" />
      </video>
      
      <Container>
        <Row className="justify-content-md-center text-center">
          <Col md={10}>
            <h1>BELLEFY INSIGHTS</h1>
            <p className="lead">
              Data For Social Impact
            </p>
            <p>
              Unlock your Data's Potential
            </p>
            <p>
              We envision a world where every organization leveraging data for social impact has the infrastructure to succeed. Bellefy Insights consolidates fragmented data sources, builds secure cloud platforms, creates dashboards, and deploys AI-powered analytics that automate repetitive work and unlock actionable insights—empowering non-profits, government agencies, and businesses to accelerate their mission and maximize their impact.
            </p>
            <a className="btn-primary btn-tech" href="mailto:contact@bellefyinsights.com">
              Contact us
            </a>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Slider;
